import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const shippingUnitService = {};

// List Shipping Unit
shippingUnitService.listShippingUnit = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "name",
    "phone_number",
    "address",
    "ward_code",
    "district_code",
    "province_code",
    "description",
    "maker_id",
    "maker_date",
    "maker.id",
    "maker.display_name",
    "checker_id",
    "checker_date",
    "checker.id",
    "checker.display_name",
    "record_status",
    "tenant_code",
  ];

  return fetchV2({
    url: `${env.API_MSP}/buses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create Shipping Unit
shippingUnitService.createShippingUnit = data => {
  return fetchV2({
    url: `${env.API_MSP}/buses`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Shipping Unit
shippingUnitService.detailShippingUnit = ({
  shippingUnitId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${shippingUnitId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Shipping Unit
shippingUnitService.updateShippingUnit = ({
  shippingUnitId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${shippingUnitId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Shipping Unit
shippingUnitService.deleteShippingUnit = ({ shippingUnitId = undefined }) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${shippingUnitId}`,
    method: "delete",
  });
};

// Active Shipping Unit
shippingUnitService.activeShippingUnit = ({
  shippingUnitId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${shippingUnitId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// List Shipping Unit
shippingUnitService.listShippingUnitAll = () => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/shipping-units-all`,
    method: "get",
  });
};

export default shippingUnitService;
